import account from './account';
import home from './home';
import invite from './inviteMember';
import profile from './profile';
import sale from './sales';
import bonus from './bonus';
import product from './product';
import search from './search';
import cart from './cart';
import order from './order';
import join from './join';
import notice from './notice';
import schedule from './schedule';
import callCenter from './callCenter';
import approve from './approve';
import marketingPlan from './marketingPlan';
import editSaleDate from './editSaleDate';
import url from './url';

export default {
    account,
    home,
    invite,
    profile,
    sale,
    bonus,
    product,
    search,
    cart,
    order,
    join,
    notice,
    schedule,
    callCenter,
    approve,
    marketingPlan,
    editSaleDate,
    url,
}